import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getHomeWarrantyFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const home = categorySpecificInfo.home;
  if (!isRecord(home)) {
    return [];
  }

  const attachments = home.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const warranty = attachments.warranty;
  if (!isRecord(warranty) || !Array.isArray(warranty.files)) {
    return [];
  }

  return warranty.files as SmartTagAttachmentFile[];
};

export const withHomeWarrantyFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const home = isRecord(categorySpecificInfo.home)
    ? categorySpecificInfo.home
    : {};
  const attachments = isRecord(home.attachments) ? home.attachments : {};
  const warranty = isRecord(attachments.warranty) ? attachments.warranty : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      home: {
        ...home,
        attachments: {
          ...attachments,
          warranty: {
            ...warranty,
            files,
          },
        },
      },
    },
  };
};

export const persistHomeWarrantyFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(db, `users/${userId}/vcards/active`, "home");
  await updateDoc(vcardRef, {
    "categorySpecificInfo.home.attachments.warranty.files": files,
    updatedAt: serverTimestamp(),
  });
};
